import React from 'react';
import classnames from 'classnames';
import License from '../../../License';
import { DetailsProps } from '../types';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';

import s from './Tier.scss';

const Tier: React.FC<DetailsProps> = ({
  deviation,
  deviation: { author, publishedTime, license },
  className,
  contentClassName,
}) => {
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
  return (
    <div className={classnames(s['root'], className, contentClassName)}>
      {isExtendedLoaded && (
        <div className={s['misc']}>
          <DeviationAttributeCSV deviation={deviation} />

          <div className={s['license']}>
            <License
              license={license}
              author={author}
              publishedTime={publishedTime}
              showSymbol={false}
            />
          </div>
        </div>
      )}
    </div>
  );
};
Tier.displayName = 'Tier';

export default Tier;
